import { useEffect } from "react";

export function useWhiteScreen() {
	useEffect(() => {
		const bodyElement = document.querySelector(".main-body");
		if (bodyElement) {
			bodyElement.className = "main-body-white";

			return () => {
				bodyElement.className = "main-body";
			};
		}
	}, []);
}
